/* Venocci – review cards (no third-party app). Renders reviews from assets/venocci-etsy-reviews.json.
   Text is always inserted with textContent (never innerHTML). No ratings are exposed as structured data.
   2026-10-08: "Etsy review" label removed from cards; the review date is shown on its own. */
(function () {
  'use strict';
  var cache = {};
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  // The data file is normally one file. It may instead list "parts" (sibling asset files, e.g.
  // venocci-etsy-reviews-p1.json) whose "reviews" arrays are joined in the listed order.
  function load(url, partUrls) {
    if (!cache[url]) {
      cache[url] = getJSON(url).then(function (data) {
        if (!data || !Array.isArray(data.parts) || !data.parts.length) return data;
        return Promise.all(data.parts.map(function (name) {
          var u = partUrls && partUrls[name];
          if (!u) throw new Error('Unknown part ' + name);
          return getJSON(u);
        })).then(function (parts) {
          var all = [];
          parts.forEach(function (p) { if (Array.isArray(p && p.reviews)) all = all.concat(p.reviews); });
          data.reviews = all;
          return data;
        });
      });
    }
    return cache[url];
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function fmtDate(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) return iso || '';
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    try { return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
    catch (e) { return iso; }
  }
  function stars(rating) {
    var r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var s = el('div', 'vetsy-card__stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', 'Rated ' + r + ' out of 5');
    var on = el('span', null, '★'.repeat(r)); on.setAttribute('aria-hidden', 'true');
    var off = el('span', 'vetsy-card__stars-off', '★'.repeat(5 - r)); off.setAttribute('aria-hidden', 'true');
    s.appendChild(on); s.appendChild(off);
    return s;
  }
  function card(rv, opts) {
    var li = el('li', 'vetsy-card');
    var art = el('article', 'vetsy-card__inner');
    art.appendChild(stars(rv.rating));
    var q = el('p', 'vetsy-card__text', rv.text);
    art.appendChild(q);
    var meta = el('div', 'vetsy-card__meta');
    meta.appendChild(el('p', 'vetsy-card__name', rv.name));
    var line = el('p', 'vetsy-card__sub');
    var t = el('time', null, fmtDate(rv.date)); t.setAttribute('datetime', rv.date);
    line.appendChild(t);
    meta.appendChild(line);
    if (opts.showScope) {
      var sc = el('p', 'vetsy-card__scope');
      if (rv.scope === 'product' && rv.product_handle) {
        sc.appendChild(document.createTextNode('Review of '));
        var a = el('a', 'link', rv.product_title || rv.product_handle);
        a.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(rv.product_handle);
        sc.appendChild(a);
      } else {
        sc.textContent = 'Shop review';
      }
      meta.appendChild(sc);
    }
    art.appendChild(meta);
    li.appendChild(art);
    return li;
  }
  function byDateDesc(a, b) { return String(b.date).localeCompare(String(a.date)) || String(a.id).localeCompare(String(b.id)); }
  function hasText(r) { return typeof r.text === 'string' && r.text.trim().length > 0; }
  // Defensive: only 4–5 star reviews with text are ever displayed, whatever the data file contains.
  function publishable(r) { var n = Number(r && r.rating); return isFinite(n) && n >= 4 && n <= 5 && hasText(r); }

  function init(root) {
    if (root.__vetsyInit) return; root.__vetsyInit = true;
    var mode = root.getAttribute('data-mode');
    var url = root.getAttribute('data-src');
    var per = Math.max(1, parseInt(root.getAttribute('data-per-page'), 10) || 6);
    var handle = root.getAttribute('data-product-handle');
    var list = root.querySelector('[data-vetsy-list]');
    var more = root.querySelector('[data-vetsy-more]');
    var status = root.querySelector('[data-vetsy-status]');
    var wrapper = root.closest('.shopify-section') || root;
    var designMode = root.hasAttribute('data-design-mode');

    var partUrls = null;
    try { partUrls = JSON.parse(root.getAttribute('data-part-urls') || 'null'); } catch (e) { partUrls = null; }
    load(url, partUrls).then(function (data) {
      var all = Array.isArray(data && data.reviews) ? data.reviews : [];
      var items;
      if (mode === 'product') {
        items = all.filter(function (r) { return r.scope === 'product' && r.product_handle === handle && publishable(r); });
      } else {
        items = all.filter(function (r) {
          return r.featured === true && (r.scope === 'product' || r.scope === 'shop') && publishable(r);
        });
      }
      items.sort(byDateDesc);
      if (!items.length) {
        if (designMode) { status.textContent = 'No reviews to show yet. Assign or feature reviews in the Venocci review manager and upload the updated data file.'; root.hidden = false; }
        else { wrapper.style.display = 'none'; }
        return;
      }
      root.hidden = false;
      var shown = 0;
      var carousel = false;
      var swipe = root.querySelector('[data-vetsy-swipe]');
      var prev = root.querySelector('[data-vetsy-prev]');
      var next = root.querySelector('[data-vetsy-next]');
      // Homepage on phones: all selected reviews in a one-at-a-time swipe row instead of a long stacked list.
      var mq = (mode !== 'product' && swipe && window.matchMedia) ? window.matchMedia('(max-width: 599px)') : null;

      function renderMore() {
        var nextItems = items.slice(shown, shown + per);
        var frag = document.createDocumentFragment();
        nextItems.forEach(function (rv) { frag.appendChild(card(rv, { showScope: mode !== 'product' })); });
        list.appendChild(frag);
        var firstNew = list.children[shown];
        shown += nextItems.length;
        more.hidden = shown >= items.length;
        status.textContent = 'Showing ' + shown + ' of ' + items.length + (mode === 'product' ? ' reviews' : ' selected reviews');
        return firstNew;
      }
      function slideWidth() {
        var c = list.children[0];
        if (!c) return list.clientWidth;
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        return c.getBoundingClientRect().width + gap;
      }
      function currentIndex() { var w = slideWidth(); return w ? Math.round(list.scrollLeft / w) : 0; }
      function updateCarousel() {
        if (!carousel) return;
        var i = Math.min(items.length - 1, Math.max(0, currentIndex()));
        prev.disabled = i <= 0;
        next.disabled = i >= items.length - 1;
        status.textContent = 'Review ' + (i + 1) + ' of ' + items.length;
        // Fit the row to the review on screen, so short reviews leave no empty space below.
        var cur = list.children[i];
        if (cur) list.style.height = cur.offsetHeight + 'px';
      }
      function setLayout() {
        var want = !!(mq && mq.matches);
        if (want === carousel && list.children.length) return;
        carousel = want;
        list.textContent = '';
        list.style.height = '';
        shown = 0;
        root.classList.toggle('vetsy--carousel', carousel);
        if (swipe) swipe.hidden = !carousel;
        if (carousel) {
          var frag = document.createDocumentFragment();
          items.forEach(function (rv) { frag.appendChild(card(rv, { showScope: true })); });
          list.appendChild(frag);
          shown = items.length;
          more.hidden = true;
          list.scrollLeft = 0;
          updateCarousel();
        } else {
          renderMore();
        }
      }
      if (prev && next) {
        prev.addEventListener('click', function () { list.scrollBy({ left: -slideWidth(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { list.scrollBy({ left: slideWidth(), behavior: 'smooth' }); });
      }
      var raf = 0;
      list.addEventListener('scroll', function () {
        if (!carousel || raf) return;
        raf = requestAnimationFrame(function () { raf = 0; updateCarousel(); });
      }, { passive: true });
      if (mq) {
        if (mq.addEventListener) mq.addEventListener('change', setLayout);
        else if (mq.addListener) mq.addListener(setLayout);
      }
      window.addEventListener('resize', function () { if (carousel) updateCarousel(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (carousel) updateCarousel(); });
      setLayout();
      more.addEventListener('click', function () {
        var first = renderMore();
        if (first) { var f = first.querySelector('.vetsy-card__inner'); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: false }); } }
      });
    }).catch(function () {
      if (designMode) { status.textContent = 'Review data file could not be loaded.'; root.hidden = false; }
      else { wrapper.style.display = 'none'; }
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-vetsy-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
